module.exports = __webpack_public_path__ + "img/05：Trofeo-2.74236460.jpg";